// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"checkbox_Checkbox__R1iFE","Box":"checkbox_Box__cJkI_","Label":"checkbox_Label__i24pr","Count":"checkbox_Count__dQ1sW"};